import { ExtendedUser, UserRoleInformative } from '../../../../store/users/types';
import React, { useEffect, useState } from 'react';
import style from './UserManagementRoleDetail.module.scss';

import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import {
  ButtonPrimary,
  DataTable,
  IconBadgeAccount,
  Loader,
  ModalContent,
  ModalHeader,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersRolesInformation } from '../../../../store/users/actions';
import { IUsersState } from '../../../../store/users/store';
import { StoreState } from '../../../../store/store';



interface IUserManagementRoleDetail {
  userInput?: ExtendedUser;
  onClose: () => void;  
  onSelectDetailUser?: (user: ExtendedUser) => void;
  onAssignRoles: () => void;
}

export const UserManagementRoleDetail: React.FunctionComponent<IUserManagementRoleDetail> = ({
  userInput,
  onClose,
  onSelectDetailUser  = () => '',
  onAssignRoles
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  

  const [isFetching, setIsFetching] = useState<boolean>(false);
	const {user} = useSelector<StoreState, IUsersState>(s => s.users);
  const [roleList, setRoleList] = useState<UserRoleInformative[]>([]);
  
  
  const u = useSelector<StoreState, IUsersState>(s => s.users);

  useEffect(() => {
    if (!userInput) {
      onClose();
    } else {
      setIsFetching(!isFetching);
			dispatch(getUsersRolesInformation(userInput.userName, userInput.userEmail));      
      onSelectDetailUser(userInput);      
    }
  }, []);

	useEffect(() => {
    if(user){
      setIsFetching(false);      
		  setRoleList(user.userRoles);
      
      
      
    }else{
      setIsFetching(true);
    }
	}, [user])
  useEffect(() => {
    console.log(u);
    
  }, [u])

  const assignRoles=()=>{
    if(userInput){
    onAssignRoles();
    
    }
  }

  const roleListCols: any[] = [
    {
      Header: t('IndustryName'),
      accessor: 'industryName',
    },
    {
      Header: t('PortalIndustry'),
      accessor: 'portalName',
    },
    {
      Header: t('country'),
      accessor: 'siteCountryDescription',
    },
    {
      Header: t('company'),
      accessor: 'companyName',
    },
    {
      Header: t('plantunit'),
      accessor: 'plantUnit',
    },
    {
      Header: t('role'),
      accessor: 'roleName',
    }
    
  ];


  return (
    <>
      <FullscreenModal onClose={onClose} className={style.modal}>
        <ModalHeader onClose={onClose}>{t('UserRoleDetail')}</ModalHeader>
        <ModalContent>
          <Loader center show={isFetching} className={style.loader} />

          {user
          ?
          <>
            <h3>User: {user.user}</h3>

            {roleList && roleList.length > 0 && (
              <section>
                <DataTable
                  columns={roleListCols}
                  data={roleList}
                  className={style.table}
                  pagination={5}
                />
              </section>
            )}
            </>
          :
          <></>
          }

          <ButtonPrimary 
            //className={stylo.actionButton}
            onClick={assignRoles}
          > 
            <IconBadgeAccount/>
            <a>{t('Assign_Roles')}</a>
          </ButtonPrimary>
          

        </ModalContent>
      </FullscreenModal>
    </>
  );
};
